import { createFileRoute } from "@tanstack/react-router";
import { motion } from 'framer-motion';

export const Route = createFileRoute("/termos-de-uso")({
  component: TermsOfUsePage,
});

function TermsOfUsePage() {
  return (
    <div className="bg-white">
      <section className="pt-40 pb-20 bg-gray-50">
        <div className="container mx-auto px-6 text-center lg:text-left">
          <h1 className="text-3xl md:text-5xl font-bold text-primary mb-8">Termos de Uso</h1>
          <div className="prose prose-lg max-w-none text-gray-600 leading-relaxed">
            <p>Ao acessar o site STOP SOM, você concorda em cumprir estes termos de serviço, todas as leis e regulamentos aplicáveis ​​e concorda que é responsável pelo cumprimento de todas as leis locais aplicáveis.</p>
            
            <h2 className="text-2xl font-bold text-primary mt-12 mb-6">1. Uso de Licença</h2>
            <p>É concedida permissão para baixar temporariamente uma cópia dos materiais no site STOP SOM, apenas para visualização transitória pessoal e não comercial.</p>
            
            <h2 className="text-2xl font-bold text-primary mt-12 mb-6">2. Isenção de Responsabilidade</h2>
            <p>Os materiais no site da STOP SOM são fornecidos 'como estão'. A STOP SOM não oferece garantias, expressas ou implícitas.</p>
            
            <h2 className="text-2xl font-bold text-primary mt-12 mb-6">3. Limitações</h2>
            <p>Em nenhum caso a STOP SOM será responsável por quaisquer danos decorrentes do uso ou da incapacidade de usar os materiais.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
